import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExchange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.2268 4.94727L1.22681 4.94726L5.17417 0.999897",
		stroke: "#1E63FF",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.22681 8L10.7268 8L6.97681 11.75",
		stroke: "#1E63FF",
		strokeLinejoin: "round"
	})]
});
export default SvgExchange;
